/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type PowerConsumptionControllerGetPowerConsumptionReportV2Format =
  (typeof PowerConsumptionControllerGetPowerConsumptionReportV2Format)[keyof typeof PowerConsumptionControllerGetPowerConsumptionReportV2Format];

export const PowerConsumptionControllerGetPowerConsumptionReportV2Format = {
  JSON: 'json',
  CSV: 'csv',
} as const;
